export var definitionTooltipStyles = function (theme) { return ({
    '& .tooltip-portal-underlined-word': {
        fontStyle: 'normal',
        borderBottom: "1px dotted ".concat(theme.palette.text.secondary),
    },
}); };
